import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {BonusBunniesParsedGameData} from "../../server/data/BonusBunniesParsedGameData";
import {TimelineLite} from "gsap";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";
import {IBonusSymbolQueue} from "../../server/data/IBonusSymbolQueue";

/**
 * Created by Jerker Nord on 2020-05-14.
 */

export class BonusBunniesBonusSymbolB5WPController extends WinPresentationController{

    private _bonusSymbolCollectedBefore:number;
    private _bonusSymbolCollectedAfter:number;
    private _bonusSymbolQueue:IBonusSymbolQueue[];
    private _bonusSymbolWinTL:TimelineLite;
    private _b5NearWinPosition:number[];

    constructor(indexes:[number, number]) {
        super(indexes, {name : "BonusBunniesBonusSymbolB5WPController", skippable : false});
    }

    protected parseFeatureGameData(data:BonusBunniesParsedGameData):void {
        this._bonusSymbolCollectedBefore = data.bonusSymbolCollectedBefore;
        this._bonusSymbolCollectedAfter = data.bonusSymbolCollectedAfter;
        this._bonusSymbolQueue = data.bonusSymbolQueue;
        this._b5NearWinPosition = data.lastBonusSymbolPositionExcitement;
    }

    protected hasWin():boolean {
        if(this._b5NearWinPosition[0] > -1) {
            return true;
        }
        return (this._bonusSymbolQueue && this._bonusSymbolQueue.length > 0);
    }

    protected startWinPresentation():void {
        if(this._bonusSymbolWinTL && this._bonusSymbolWinTL.isActive()) {
            this._bonusSymbolWinTL.pause();
            this._bonusSymbolWinTL.kill();
        }
        this._bonusSymbolWinTL = new TimelineLite();
        if(this._b5NearWinPosition[0] > -1) {
            BonusBunniesGameModuleConfig.bonusBunniesB5NearWinView.removeNearWinAnimation();
        }
        BonusBunniesGameModuleConfig.bonusBunniesHarvesterWinView.animationCounter = 0;
        BonusBunniesGameModuleConfig.bonusBunniesFertilizerWinView.animationCounter = 0;
        for(let i:number = 0; i < this._bonusSymbolQueue.length; i++) {
            if(this._bonusSymbolQueue[i].symbol == "B5") {
                this._bonusSymbolWinTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesB5NearWinView.removeNearWinAnimation());
                this._bonusSymbolWinTL.add(BonusBunniesGameModuleConfig.bonusBunniesB5WinView.b5WinAnimation(this._bonusSymbolQueue[i]));
            }
        }
        this._bonusSymbolWinTL.add(() => this.finish());
    }

    protected stopWinPresentation(isAborted:boolean):void {

    }
}